
export default [
  {
    path: '/search/:examBoard',
    name: 'search',
    component: () => import('@/views/search/SearchView.vue')
  },{
    path: '/check-sol',
    name: 'check-sol',
    component: () => import('@/views/search/CheckSolView.vue')
  },
];